export const DISABLE_ONBOARDING_STEP = 'disableOnboardingStep'
export const UPDATE_ONBOARDING = 'updateOnboarding'
export const SLICE_NAME_ONBOARDING = 'onboarding'
